<div
  id="mapTemplate"
  class="hide"
  [style.width]="width"
  [style.height]="height"
>
  {{ dataString | json }}
</div>
